export default {
  props: {
    showSaveAs: {
      type: Boolean,
      default: true
    },
    showSave: {
      type: Boolean,
      default: true
    },
    disabledSaveTemplate: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    handleShare() {
      this.$emit('share')
    },
    handleReset() {
      this.$emit('reset')
    },
    handleSave() {
      this.$emit('save')
    },
    handleSaveAs() {
      this.$emit('saveAs')
    },
    handleApply() {
      this.$emit('apply')
    },
    handleCancel() {
      this.$emit('cancel')
    }
  },
  render() {
    const { showSave, showSaveAs, disabledSaveTemplate } = this
    return (
      <div class="field-config-footer">
        <div class="field-config-footer-left">
          <kye-button type="text" icon="layout layout-fenxiang" onClick={this.handleShare}>分享</kye-button>
          <kye-button type="text" icon="layout layout-reset" onClick={this.handleReset}>重置</kye-button>
        </div>
        <div class="field-config-footer-right">
          {showSave && <kye-button type="primary" icon="layout layout-pen" disabled={disabledSaveTemplate} onClick={this.handleSave}>保存</kye-button>}
          {showSaveAs && <kye-button type="primary" icon="layout layout-saveas" onClick={this.handleSaveAs}>另存为</kye-button>}
          <kye-button type="primary" hotkey="ctrl+s" onClick={this.handleApply}>应用(S)</kye-button>
          <kye-button onClick={this.handleCancel}>取消</kye-button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/components/dialog-footer.js